import { render } from "./BackIcon.vue?vue&type=template&id=288d7a7c&scoped=true"
const script = {}

import "./BackIcon.vue?vue&type=style&index=0&id=288d7a7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-288d7a7c"]])

export default __exports__